module.exports = __webpack_public_path__ + "prod/1.42.2/img/renshi-six.53026335.png";